<template lang="pug">

  div

    v-dialog(v-model="isVisible" max-width="1300px" width="95%" :persistent="loading" content-class="sosDialog--newDuty")

      .dialogHeader

        .dialogHeaderTitle
          | Novo plantão

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="isVisible = false")

      .dialogBody

        .dialogBodyContent

          //-
            -
            - 1) Configuração inicial: Escala + Destino dos slots (Owner) + Tempo de consulta
            -

          .sosFieldsRow

            .createTurnField.createTurnField--first.sosFieldsRow__field
              sos-select(:fullscreen="true" fullscreenTitle="Escala" :fullscreenAutoWidth="true" :autoHeight="true" label="Escala" :labelDescription="listeners.loadingGroupScales === 'no' && processedGroupScales.length === 0 ? '(Nota: O grupo não tem escalas)' : ''" :items="selectScales" @sosSelectChanged="onSelectScale" :default="scaleID" :disabled="loading")

            .createTurnField.sosFieldsRow__field
              sos-select(label="Destino dos slots" labelDescription="(Município ou Reservado)" :items="OWNER_OPTIONS" @sosSelectChanged="onSelectOwner" :default="slotOwner" :disabled="loading" defaultEmpty="Selecione")

            .createTurnField.sosFieldsRow__field
              sos-select(label="Tempo de consulta" labelDescription="(minutos)" :items="BLOCK_DURATION_OPTIONS" @sosSelectChanged="onSelectSlotDuration" :default="slotDuration" :disabled="loading" defaultEmpty="Selecione")

          //-
            -
            - 2) Seleção de plantões (datas)
            -

          .createTurnField
            label.csLabel
              span(v-html="'Datas dos plantões'")
            .csFields.csFields--date
              date-picker(v-model="dutyDate" :multiple="true" valueType="format" format="DD/MM/YYYY" :lang="lang" @change="onSelectData" class="groupUserField--date" :disabled="loading")
            .sosFieldHint (Selecione até 20 dias)

          //-
            -
            - 3) Configuração padrão dos plantões
            -

          .sosDefaultConfigBlock

            .sosFieldsRow

              .createTurnField.sosFieldsRow__field
                sos-time-select(
                  label="Horário de início padrão"
                  labelDescription="(Entre 07:00 e 19:55)"
                  :hours="allowedHours"
                  :minutes="allowedMinutes"
                  @sosSelectChanged="onSelectDefaultTime"
                  :default="defaultStartTime"
                  :disabled="loading"
                )

              .createTurnField.sosFieldsRow__field
                sos-select(
                  label="Duração padrão"
                  labelDescription="(Em horas)"
                  :items="allowedDurationHours"
                  @sosSelectChanged="onSelectDefaultDuration"
                  :default="defaultDurationHours"
                  :disabled="loading"
                  defaultEmpty="Duração"
                )

          //-
            -
            - 4) Tabela de plantões selecionados (editável por dia)
            -

          template(v-if="perDutyList.length > 0")

            .sosSectionTitle Plantões selecionados

            .sosTableScroll
              table.sosDataTable.sosDutiesTable
                thead
                  tr
                    th Data
                    th Início
                    th Duração (h)
                    th Fim
                    th Minutos
                    th Slots disp.
                    th Valor previsto
                    th &nbsp;
                tbody
                  tr(v-for="duty in perDutyList" :key="duty.date")
                    td.sosDutiesTable__date {{ duty.date }}
                    td.sosDutiesTable__time
                      sos-time-select(
                        label=""
                        :hours="allowedHours"
                        :minutes="allowedMinutes"
                        @sosSelectChanged="time => onPerDutyStartInput(duty.date, time)"
                        :default="duty.startTime"
                        :disabled="loading"
                      )
                    td.sosDutiesTable__duration
                      sos-select(
                        label=""
                        :items="allowedDurationHoursFor(duty.startTime.hour)"
                        @sosSelectChanged="hour => onPerDutyDurationInput(duty.date, hour)"
                        :default="duty.durationHours > 0 ? String(duty.durationHours).padStart(2, '0') : ''"
                        :disabled="loading"
                        defaultEmpty="Duração"
                      )
                    td.sosDutiesTable__end {{ duty.endLabel || '-' }}
                    td.sosDutiesTable__minutes {{ duty.durationMinutes }}
                    td.sosDutiesTable__slots {{ duty.slotsCapacity }}
                    td.sosDutiesTable__value {{ duty.valueFormatted }}
                    td.sosDutiesTable__remove
                      .mdi.mdi-close-circle(@click="!loading && removeDuty(duty.date)")

          //-
            -
            - 5) Distribuição por slots (contagem por tipo)
            -

          .createTurnField.mt-4.mb-3(v-if="slotOwner.length > 0 && slotDuration.length > 0")
            div(style="color: #495057; font-size: 15px; font-weight: 500; line-height: 20px; letter-spacing: normal") Distribuição das vagas por tipo:
            div(style="color: #6c757d; font-size: 12px; line-height: 16px; margin-bottom: 8px") Informe, para cada tipo, a quantidade TOTAL de vagas (somando todos os plantões selecionados). As vagas serão distribuídas da forma mais simétrica possível entre os plantões, respeitando a capacidade de cada um.

            .sosFieldsRow
              .sosFieldsRow__field(v-for="type in TYPE_ORDER" :key="type")
                v-text-field(:value="slotTypeCounts[type]" @input="value => onSlotTypeCountInput(type, value)" :label="SLOT_TYPE_LABELS[type]" type="number" min="0" :disabled="loading")

          //-
            -
            - 6) Dashboard
            -

          .sosDashboard(v-if="slotOwner.length > 0 && slotDuration.length > 0")

            .sosDashboard__grid

              .sosDashboardCard
                .sosDashboardCard__label Destino
                .sosDashboardCard__value {{ OWNER_LABELS[slotOwner] || '-' }}

              .sosDashboardCard
                .sosDashboardCard__label Tempo de consulta
                .sosDashboardCard__value {{ `${slotDuration} min` }}

              .sosDashboardCard
                .sosDashboardCard__label Total de plantões
                .sosDashboardCard__value {{ totalPlantoes }}

              .sosDashboardCard
                .sosDashboardCard__label Total de horas
                .sosDashboardCard__value {{ `${totalHours}h` }}

              .sosDashboardCard
                .sosDashboardCard__label Total de minutos
                .sosDashboardCard__value {{ `${totalMinutes} min` }}

              .sosDashboardCard
                .sosDashboardCard__label Slots totais
                .sosDashboardCard__value {{ totalAvailableSlots }}

              .sosDashboardCard
                .sosDashboardCard__label Slots distribuídos
                .sosDashboardCard__value {{ distributedSlotsCount }}

              .sosDashboardCard(:class="{ 'sosDashboardCard--error': remainingSlots < 0 }")
                .sosDashboardCard__label Slots restantes
                .sosDashboardCard__value {{ remainingSlots }}

            .sosProgressBar
              .sosProgressBar__track
                .sosProgressBar__fill(:style="{ width: `${distributionPercent}%` }" :class="{ 'sosProgressBar__fill--over': remainingSlots < 0 }")
              .sosProgressBar__label {{ `${distributionPercent}% distribuído` }}

            .sosAlertBanner.sosAlertBanner--error(v-if="remainingSlots < 0")
              | A quantidade de vagas configurada excede o total de slots disponíveis nos plantões selecionados.

            .sosAlertBanner.sosAlertBanner--error(v-else-if="distributedSlotsByDuty.capacityError")
              | Não foi possível distribuir todas as vagas configuradas entre os plantões selecionados (capacidade insuficiente).

            .sosAlertBanner(v-else-if="remainingSlots > 0")
              | Ainda restam {{ remainingSlots }} slot(s) disponível(is) sem distribuição.

          //-
            -
            - 7) Resultado da distribuição
            -

          template(v-if="distributionResult.totalSlots > 0")

            .sosSectionTitle Resultado da distribuição

            .sosTableScroll
              table.sosDataTable.sosResultTable
                thead
                  tr
                    th Tipo
                    th Slots
                    th Percentual
                    th Minutos usados
                tbody
                  tr(v-for="row in distributionResult.rows" :key="row.type")
                    td {{ row.label }}
                    td {{ row.slots }}
                    td {{ `${row.percent.toFixed(1)}%` }}
                    td {{ `${row.minutesUsed} min` }}
                tfoot
                  tr
                    th Total
                    th {{ distributionResult.totalSlots }}
                    th {{ `${distributionResult.totalPercent.toFixed(1)}%` }}
                    th {{ `${distributionResult.totalMinutesUsed} min` }}

          //-
            -
            - 8) Prévia dos slots gerados
            -

          template(v-if="generatedSlotsPreview.length > 0")

            .sosSectionTitle Prévia dos slots gerados

            .sosTableScroll
              table.sosDataTable.sosPreviewTable
                thead
                  tr
                    th #
                    th Data
                    th Início
                    th Fim
                    th Destino
                    th Tipo
                    th Duração
                    th Plantão
                tbody
                  tr(v-for="(slot, index) in generatedSlotsPreview" :key="slot.key")
                    td {{ index + 1 }}
                    td {{ slot.date }}
                    td {{ slot.startLabel }}
                    td {{ slot.endLabel }}
                    td {{ slot.ownerLabel }}
                    td {{ slot.typeLabel }}
                    td {{ `${slot.duration} min` }}
                    td {{ slot.dutyLabel }}

          //-
            -
            - 9) Resumo por plantão
            -

          template(v-if="perDutySummary.length > 0")

            .sosSectionTitle Resumo por plantão

            .sosTableScroll
              table.sosDataTable.sosSummaryTable
                thead
                  tr
                    th Data
                    th Início
                    th Fim
                    th 1ª consulta
                    th Retorno
                    th Ambos
                    th Total
                tbody
                  tr(v-for="summary in perDutySummary" :key="summary.date")
                    td {{ summary.date }}
                    td {{ summary.startLabel || '-' }}
                    td {{ summary.endLabel || '-' }}
                    td {{ summary.counts.FIRST_APPOINTMENT }}
                    td {{ summary.counts.FOLLOW_UP }}
                    td {{ summary.counts.FREE }}
                    td {{ summary.total }}

          //-
            -
            - Valor hora / base de cálculo
            -

          .createTurnField
            sos-select(label="Valor hora desejado" :items="selectBases" @sosSelectChanged="onSelectBase" :default="selectedCalculationBase" :disabled="loading")

          //-
            -
            - Ações
            -

          .mt-7.text-right
            sos-button(@buttonClick="createDuty" buttonLabel="Criar plantão" buttonIcon="mdi-plus" buttonIconSize="20" size="medium" color="success" :loading="loading")

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdAction")

</template>

<script>

  // Vuex
  import { mapState } from 'vuex'

  import dateTimeLanguage from '@/constants/dateTimeLanguage'

  import { canAddUserShift } from '@/functions'
  import { apiCreateDuties } from '@/services/duties'
  import { apiSetDutySlots } from '@/services/endpoints/slots'
  import { formatMoney } from '@/mixins/utils'
  import { CONSULTATION_DURATION_OPTIONS } from '@/constants/enums/consultation'

  import confirmDialogMixin from '@/mixins/cd.mixin.js'

  import DatePicker from 'vue2-datepicker'
  import 'vue2-datepicker/index.css'

  import SosTimeSelect from '@/components/SosTimeSelect'
  import ConfirmDialog from '@/modals/ConfirmDialog'
  import SosSelect from '@/components/SosSelect'
  import SosButton from '@/components/SosButton'
  import SosHybridTimeSelect from '@/components/SosHybridTimeSelect.vue'

  import moment from 'moment'
  import 'moment/locale/pt-br'
  moment.locale('pt-BR')

  // --- TIPO da vaga (Portal Consultas): rótulos dos 3 tipos possíveis
  const SLOT_TYPE_LABELS = {
    FIRST_APPOINTMENT: '1ª consulta',
    FOLLOW_UP: 'Retorno',
    FREE: 'Ambos',
  }

  // --- Ordem canônica (fixa, sem controle na tela) usada tanto para montar a fila de distribuição das
  //     vagas entre os plantões quanto para ordenar a timeline de cada plantão: 1ª consulta -> Retorno -> Ambos
  const TYPE_ORDER = ['FIRST_APPOINTMENT', 'FOLLOW_UP', 'FREE']

  const OWNER_LABELS = {
    MUNICIPIO: 'Município',
    RESERVADO: 'Reservado',
  }

  export default {
    name: 'NewUserDutyModal',

    components: {
      'sos-select': SosSelect,
      'sos-time-select': SosTimeSelect,
      'sos-hybrid-time-select': SosHybridTimeSelect,
      'sos-button': SosButton,
      'date-picker': DatePicker,
      'confirm-dialog': ConfirmDialog,
    },

    mixins: [
      confirmDialogMixin,
    ],

    data () {
      return {
        isVisible: false,
        loading: false,

        startHours: Array.from({ length: 24 }, (_, i) => {
          const hour = i.toString().padStart(2, '0');
          return { key: `start-hour-${hour}`, value: hour, text: hour };
        }),
        durationHours: Array.from({ length: 25 }, (_, i) => {
          const hour = i.toString().padStart(2, '0');
          return { key: `duration-hour-${hour}`, value: hour, text: hour };
        }),

        // --- BASE DO CÁLCULO DO VALOR DO PLANTÃO
        selectedCalculationBase: 'user_scale',

        // --- VALOR HORA DO USUÁRIO (GRUPO)
        userGroupHourlyRate: 0,
        userGroupHourlyRateFormatted: 'R$ 0,00',

        // --- VALOR HORA DO USUÁRIO (ESCALA SELECIONADA)
        userSelectedScaleHourlyRate: 0,
        userSelectedScaleHourlyRateFormatted: 'R$ 0,00',

        // Valor hora do usuário de segunda a sexta
        userSelectedScaleWeekdaysHourlyRate: 0,
        userSelectedScaleWeekdaysHourlyRateFormatted: 'R$ 0,00',

        // Valor hora do usuário de final de semana
        userSelectedScaleWeekendHourlyRate: 0,
        userSelectedScaleWeekendHourlyRateFormatted: 'R$ 0,00',

        // Valor hora do usuário (diurno)
        userSelectedScaleDayShiftHourlyRate: 0,
        userSelectedScaleDayShiftHourlyRateFormatted: 'R$ 0,00',

        // Valor hora do usuário (noturno)
        userSelectedScaleNightShiftHourlyRate: 0,
        userSelectedScaleNightShiftHourlyRateFormatted: 'R$ 0,00',

        // Valor hora do usuário de segunda a sexta (diurno)
        userSelectedScaleWeekdaysDayShiftHourlyRate: 0,
        userSelectedScaleWeekdaysDayShiftHourlyRateFormatted: 'R$ 0,00',

        // Valor hora do usuário de segunda a sexta (noturno)
        userSelectedScaleWeekdaysNightShiftHourlyRate: 0,
        userSelectedScaleWeekdaysNightShiftHourlyRateFormatted: 'R$ 0,00',

        // Valor hora do usuário de final de semana (diurno)
        userSelectedScaleWeekendDayShiftHourlyRate: 0,
        userSelectedScaleWeekendDayShiftHourlyRateFormatted: 'R$ 0,00',

        // Valor hora do usuário de final de semana (noturno)
        userSelectedScaleWeekendNightShiftHourlyRate: 0,
        userSelectedScaleWeekendNightShiftHourlyRateFormatted: 'R$ 0,00',

        // --- MÊS/ANO SELECIONADO/CARREGADO
        selectedMonth: null,
        selectedYear: null,

        // --- Escala
        scaleID: '',

        // --- Valor da escala
        scaleValue: 0,
        scaleValueFormatted: 'R$ 0,00',

        // --- Data
        dutyDate: [],

        // --- Allowed
        allowedHours: [{ key: '07', text: '07', value: '07' }, { key: '08', text: '08', value: '08' }, { key: '09', text: '09', value: '09' }, { key: '10', text: '10', value: '10' }, { key: '11', text: '11', value: '11' }, { key: '12', text: '12', value: '12' }, { key: '13', text: '13', value: '13' }, { key: '14', text: '14', value: '14' }, { key: '15', text: '15', value: '15' }, { key: '16', text: '16', value: '16' }, { key: '17', text: '17', value: '17' }, { key: '18', text: '18', value: '18' }, { key: '19', text: '19', value: '19' }],
        allowedMinutes: [{ key: '00', text: '00', value: '00' }, { key: '05', text: '05', value: '05' }, { key: '10', text: '10', value: '10' }, { key: '15', text: '15', value: '15' }, { key: '20', text: '20', value: '20' }, { key: '25', text: '25', value: '25' }, { key: '30', text: '30', value: '30' }, { key: '35', text: '35', value: '35' }, { key: '40', text: '40', value: '40' }, { key: '45', text: '45', value: '45' }, { key: '50', text: '50', value: '50' }, { key: '55', text: '55', value: '55' }],
        allowedDurationHours: [{ key: 'dh_01', text: '01', value: '01' }, { key: 'dh_02', text: '02', value: '02' }, { key: 'dh_03', text: '03', value: '03' }, { key: 'dh_04', text: '04', value: '04' }, { key: 'dh_05', text: '05', value: '05' }, { key: 'dh_06', text: '06', value: '06' }, { key: 'dh_07', text: '07', value: '07' }, { key: 'dh_08', text: '08', value: '08' }, { key: 'dh_09', text: '09', value: '09' }, { key: 'dh_10', text: '10', value: '10' }, { key: 'dh_11', text: '11', value: '11' }, { key: 'dh_12', text: '12', value: '12' }],

        selectBases: [
          { key: 'base_scale', value: 'scale', text: 'Valor hora da escala selecionada' },
          { key: 'base_user_scale', value: 'user_scale', text: 'Valor hora do usuário na escala selecionada' },
          { key: 'base_user_group', value: 'user_group', text: 'Valor hora do usuário no grupo' },
        ],

        lang: dateTimeLanguage,

        // --- Durações de consulta permitidas (mesmo conjunto usado nas escalas, exceto "Desativado")
        BLOCK_DURATION_OPTIONS: CONSULTATION_DURATION_OPTIONS.filter(o => o.value !== '0'),

        // --- Destino (owner) único dos slots do Portal Consultas, escolhido no topo do modal
        slotOwner: '', // 'MUNICIPIO' | 'RESERVADO'
        OWNER_OPTIONS: [
          { key: 'owner_municipio', value: 'MUNICIPIO', text: 'Município' },
          { key: 'owner_reservado', value: 'RESERVADO', text: 'Reservado' },
        ],

        // --- Duração (minutos) de UMA consulta/vaga, usada tanto para calcular a capacidade de slots de
        //     cada plantão quanto para preencher o "tempo_consulta"/scaleConsultationDuration do plantão
        slotDuration: '',

        // --- Configuração padrão, aplicada automaticamente a todos os plantões já selecionados sempre
        //     que o horário de início ou a duração padrão forem alterados (ver onSelectDefaultTime/onSelectDefaultDuration)
        defaultStartTime: { hour: '', minute: '00' },
        defaultDurationHours: '',

        // --- Configuração individual (editável) de cada plantão selecionado: [{ date, startHour, startMinute, durationHours }]
        perDutyConfig: [],

        // --- Quantidade TOTAL (somando todos os plantões selecionados) de vagas por tipo clínico. Essas
        //     vagas são distribuídas (não replicadas) entre os plantões, da forma mais simétrica possível
        //     (ver computed distributedSlotsByDuty)
        slotTypeCounts: { FIRST_APPOINTMENT: 0, FOLLOW_UP: 0, FREE: 0 },

        // --- Constantes expostas para o template
        TYPE_ORDER,
        SLOT_TYPE_LABELS,
        OWNER_LABELS,
      }
    },

    computed: {
      ...mapState({
        listeners: state => state.app.listeners,
        groupScales: state => state.app.groupScales,
      }),

      // Datas válidas selecionadas no formulário (DD/MM/YYYY)
      validDatesList ()
      {
        return Array.isArray(this.dutyDate) && this.dutyDate.length > 0 ? this.dutyDate.filter(date => /^\d{2}[./-]\d{2}[./-]\d{4}$/.test(date)) : []
      },

      // Lista "normalizada" de cada plantão selecionado, com horário de início/fim, minutos, capacidade
      // de slots (com base no tempo de consulta escolhido) e valor previsto — tudo calculado
      // individualmente, já que agora cada plantão pode ter seu próprio horário de início e duração
      perDutyList ()
      {
        const slotDuration = parseInt(this.slotDuration) || 0

        return this.perDutyConfig.map(entry => {
          const startHour = entry.startHour || ''
          const startMinute = entry.startMinute || '00'
          const startTime = { hour: startHour, minute: startMinute }
          const startLabel = startHour.length > 0 ? `${startHour}:${startMinute}` : ''

          const durationHours = parseInt(entry.durationHours) || 0
          const durationMinutes = durationHours * 60

          const endLabel = (startHour.length > 0 && durationMinutes > 0)
            ? moment.utc('2000-01-01T00:00:00').add(parseInt(startHour), 'hours').add(parseInt(startMinute), 'minutes').add(durationMinutes, 'minutes').format('HH:mm')
            : ''

          const slotsCapacity = slotDuration > 0 ? Math.floor(durationMinutes / slotDuration) : 0
          const value = (startHour.length > 0 && durationMinutes > 0) ? this.computeDutyValue(entry.date, durationMinutes, startHour) : 0

          return {
            date: entry.date,
            startTime,
            startLabel,
            durationHours,
            durationMinutes,
            endLabel,
            slotsCapacity,
            value,
            valueFormatted: formatMoney(value),
          }
        })
      },

      totalPlantoes ()
      {
        return this.perDutyList.length
      },

      totalMinutes ()
      {
        return this.perDutyList.reduce((sum, duty) => sum + duty.durationMinutes, 0)
      },

      totalHours ()
      {
        return Math.round((this.totalMinutes / 60) * 10) / 10
      },

      totalAvailableSlots ()
      {
        return this.perDutyList.reduce((sum, duty) => sum + duty.slotsCapacity, 0)
      },

      distributedSlotsCount ()
      {
        return TYPE_ORDER.reduce((sum, type) => sum + (parseInt(this.slotTypeCounts[type]) || 0), 0)
      },

      remainingSlots ()
      {
        return this.totalAvailableSlots - this.distributedSlotsCount
      },

      distributionPercent ()
      {
        if (!(this.totalAvailableSlots > 0)) return 0
        return Math.min(100, Math.round((this.distributedSlotsCount / this.totalAvailableSlots) * 100))
      },

      // Resultado da distribuição por tipo: quantidade de slots, minutos usados e percentual sobre o
      // total de slots disponíveis nos plantões selecionados
      distributionResult ()
      {
        const duration = parseInt(this.slotDuration) || 0
        const totalAvailableSlots = this.totalAvailableSlots

        const rows = TYPE_ORDER.map(type => {
          const slots = parseInt(this.slotTypeCounts[type]) || 0
          const minutesUsed = slots * duration
          const percent = totalAvailableSlots > 0 ? (slots / totalAvailableSlots) * 100 : 0

          return { type, label: SLOT_TYPE_LABELS[type], slots, minutesUsed, percent }
        })

        return {
          rows,
          totalSlots: rows.reduce((sum, row) => sum + row.slots, 0),
          totalMinutesUsed: rows.reduce((sum, row) => sum + row.minutesUsed, 0),
          totalPercent: rows.reduce((sum, row) => sum + row.percent, 0),
        }
      },

      //
      // Distribui (round-robin, respeitando a capacidade de slots de cada plantão) as vagas de cada tipo
      // (slotTypeCounts) entre os plantões selecionados, da forma mais simétrica possível. Retorna
      // { duties, capacityError }, onde "duties" é um array (mesmo tamanho/ordem de perDutyList) com a
      // lista de vagas de cada plantão (já ordenada pela ordem canônica de tipos, com
      // slotIndex/offsetStartMinutes calculados), e "capacityError" indica que alguma vaga não coube em
      // nenhum plantão (todos já sem capacidade restante)
      //

      distributedSlotsByDuty ()
      {
        const duration = parseInt(this.slotDuration) || 0
        const perDutyList = this.perDutyList
        const dutiesCount = perDutyList.length

        const queue = []

        if (duration > 0 && this.slotOwner.length > 0) {
          TYPE_ORDER.forEach(type => {
            const count = parseInt(this.slotTypeCounts[type]) || 0
            for (let i = 0; i < count; i++) queue.push({ slotType: type, ownerType: this.slotOwner, duration })
          })
        }

        const dutyRemaining = perDutyList.map(duty => duty.slotsCapacity)
        const dutySlots = Array.from({ length: dutiesCount }, () => [])

        let pointer = 0
        let capacityError = false

        queue.forEach(unit => {
          let placedIndex = -1

          for (let step = 0; step < dutiesCount; step++) {
            const idx = (pointer + step) % dutiesCount
            if (dutyRemaining[idx] > 0) {
              placedIndex = idx
              break
            }
          }

          if (placedIndex === -1) {
            capacityError = true
            return
          }

          dutySlots[placedIndex].push(unit)
          dutyRemaining[placedIndex] -= 1
          pointer = (placedIndex + 1) % dutiesCount
        })

        const typeRank = { FIRST_APPOINTMENT: 0, FOLLOW_UP: 1, FREE: 2 }

        const duties = dutySlots.map(slotsForDuty => {
          const ordered = [...slotsForDuty].sort((a, b) => typeRank[a.slotType] - typeRank[b.slotType])

          let cursorMinutes = 0

          return ordered.map((slot, slotIndex) => {
            const offsetStartMinutes = cursorMinutes
            cursorMinutes += slot.duration

            return { ...slot, slotIndex, offsetStartMinutes }
          })
        })

        return { duties, capacityError }
      },

      // Lista achatada (para a prévia) de cada vaga que será efetivamente criada, na ordem de cada plantão
      generatedSlotsPreview ()
      {
        const rows = []
        const { duties } = this.distributedSlotsByDuty

        this.perDutyList.forEach((duty, dutyIndex) => {
          if (duty.startTime.hour.length === 0) return

          const dutySlots = duties[dutyIndex] || []
          if (dutySlots.length === 0) return

          const dutyStartMoment = moment.utc('2000-01-01T00:00:00').add(parseInt(duty.startTime.hour), 'hours').add(parseInt(duty.startTime.minute), 'minutes')

          dutySlots.forEach(slot => {
            const slotStartMoment = dutyStartMoment.clone().add(slot.offsetStartMinutes, 'minutes')
            const slotEndMoment = slotStartMoment.clone().add(slot.duration, 'minutes')

            rows.push({
              key: `${duty.date}_${slot.slotIndex}_${slot.slotType}`,
              date: duty.date,
              startLabel: slotStartMoment.format('HH:mm'),
              endLabel: slotEndMoment.format('HH:mm'),
              ownerLabel: OWNER_LABELS[this.slotOwner] || '',
              typeLabel: SLOT_TYPE_LABELS[slot.slotType],
              duration: slot.duration,
              dutyLabel: `${duty.date} ${duty.startLabel}`,
            })
          })
        })

        return rows
      },

      // Resumo por plantão: contagem de cada tipo de vaga e total, além dos horários já calculados
      perDutySummary ()
      {
        const { duties } = this.distributedSlotsByDuty

        return this.perDutyList.map((duty, dutyIndex) => {
          const dutySlots = duties[dutyIndex] || []
          const counts = { FIRST_APPOINTMENT: 0, FOLLOW_UP: 0, FREE: 0 }

          dutySlots.forEach(slot => { counts[slot.slotType] += 1 })

          return {
            date: duty.date,
            startLabel: duty.startLabel,
            endLabel: duty.endLabel,
            counts,
            total: dutySlots.length,
          }
        })
      },

      processedGroupScales () {
        return !!this.groupScales === true && Array.isArray(this.groupScales) && this.groupScales.length > 0 ? this.groupScales : []
      },

      selectScales ()
      {
        if (this.processedGroupScales.length === 0) return []

        const userID = this.$route.params.userID

        // ESCALAS DE CADA USUÁRIO DO GRUPO
        const userScales = this.processedGroupScales.filter(gs => gs.scaleRelatedUsers.some(relatedUserID => relatedUserID === userID)).map(gs => gs.scaleID)

        return this.processedGroupScales.filter(s => {
          const scaleConsultationDuration = Number(s.scaleConsultationDuration || '0')
          const userScaleConsultationDuration = Number(!!s === true && !!s.scaleUsers === true && !!s.scaleUsers[this.$route.params.userID] === true && !!s.scaleUsers[this.$route.params.userID].consultationtime === true ? s.scaleUsers[this.$route.params.userID].consultationtime : '0')

          return (
            (scaleConsultationDuration > 0 || userScaleConsultationDuration > 0) && (
              // Usuário relacionado a todas as escalas (Nota: Segundo a regra de negócio = Nenhuma escala relacionada)
              userScales.length === 0 ||
              (
                // Usuário encontrado + Relacionado a escala do plantão a ser dividido
                userScales.length > 0 &&
                userScales.some(scaleID => scaleID === s.scaleID)
              )
            )
          )
        }).map(s => {
          const userSelectedScaleHasHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].hourlyrate === true
          const userSelectedScaleHourlyRate = userSelectedScaleHasHourlyRate ? s.scaleUsers[userID].hourlyrate : 0
          const userSelectedScaleHourlyRateFormatted = formatMoney(userSelectedScaleHourlyRate)

          const scaleConsultationDuration = Number(s.scaleConsultationDuration || '0')
          const userScaleConsultationDuration = Number(!!s === true && !!s.scaleUsers === true && !!s.scaleUsers[this.$route.params.userID] === true && !!s.scaleUsers[this.$route.params.userID].consultationtime === true ? s.scaleUsers[this.$route.params.userID].consultationtime : '0')

          const scaleConsultationDurationText = scaleConsultationDuration === 0 ? 'Desativado' : `${scaleConsultationDuration} min`
          const userScaleConsultationDurationText = userScaleConsultationDuration === 0 ? 'Desativado' : `${userScaleConsultationDuration} min`

          return {
            key: `scale_${s.scaleID}`,
            value: s.scaleID,
            text: `<span class="journeyOption">${s.scaleName}<br />` + (
              scaleConsultationDuration > 0 && userScaleConsultationDuration > 0 ? (
                `<span class="journeyOptionObservation"><span class="journeyBold">Duração da consulta</span>: ${scaleConsultationDurationText} <i class="journeyGray">(Escala)</i> ou ${userScaleConsultationDurationText} <i class="journeyGray">(Usuário na escala)</i></span>`
              ) : (
                scaleConsultationDuration > 0 && userScaleConsultationDuration === 0 ? (
                  `<span class="journeyOptionObservation"><span class="journeyBold">Duração da consulta</span>: ${scaleConsultationDurationText} <i class="journeyGray">(Escala)</i></span>`
                ) : (
                  `<span class="journeyOptionObservation"><span class="journeyBold">Duração da consulta</span>: ${userScaleConsultationDurationText} <i class="journeyGray">(Usuário)</i></span>`
                )
              )
            ) + (
              `<br /><span class="journeyOptionObservation"><span class="journeyBold">Valor hora</span>: ${s.scaleValueFormatted} <i class="journeyGray">(Escala)</i> ou ${userSelectedScaleHourlyRateFormatted} <i class="journeyGray">(Usuário na escala)</i></span></span>`
            ),
          }
        })
      },
    },

    watch: {
      '$store.state.app.groupScales': function ()
      {
        const defaultScale = !!this.$store.state.app.groupScales === true && this.$store.state.app.groupScales.length > 0 ? this.$store.state.app.groupScales[0] : null

        if (!!defaultScale === true) this.setScale(defaultScale)
      },
    },

    mounted () {
      this.dutyDate = [moment().format('DD/MM/YYYY')]
      this.syncPerDutyConfig()

      //
      // CORREÇÃO: LÊ ALGUNS DADOS DA ESCALA QUANDO O USUÁRIO SAI DA TELA "PLANTÕES DO USUÁRIO" E VOLTA
      //

      const defaultScale = !!this.$store.state.app.groupScales === true && this.$store.state.app.groupScales.length > 0 ? this.$store.state.app.groupScales[0] : null

      if (!!defaultScale === true) this.setScale(defaultScale)
    },

    methods: {
      //
      //
      //

      open (selectedYear, selectedMonth, userGroupHourlyRate)
      {
        this.selectedYear = selectedYear
        this.selectedMonth = selectedMonth

        this.userGroupHourlyRate = userGroupHourlyRate
        this.userGroupHourlyRateFormatted = formatMoney(userGroupHourlyRate)

        this.slotOwner = ''
        this.slotDuration = ''

        this.defaultStartTime = { hour: '', minute: '00' }
        this.defaultDurationHours = ''

        this.slotTypeCounts = { FIRST_APPOINTMENT: 0, FOLLOW_UP: 0, FREE: 0 }

        this.syncPerDutyConfig()

        this.isVisible = true
      },

      //
      // Sincroniza perDutyConfig com as datas selecionadas: cria uma entrada (com os defaults atuais)
      // para cada data nova, remove as entradas de datas desmarcadas e preserva as edições das datas
      // mantidas
      //

      syncPerDutyConfig ()
      {
        const existingByDate = {}
        this.perDutyConfig.forEach(entry => { existingByDate[entry.date] = entry })

        this.perDutyConfig = this.validDatesList.map(date => existingByDate[date] || {
          date,
          startHour: this.defaultStartTime.hour,
          startMinute: this.defaultStartTime.minute,
          durationHours: this.defaultDurationHours,
        })
      },

      onPerDutyStartInput (date, time)
      {
        const entry = this.perDutyConfig.find(item => item.date === date)
        if (!entry) return

        this.$set(entry, 'startHour', time.hour)
        this.$set(entry, 'startMinute', time.minute)
      },

      onPerDutyDurationInput (date, durationHours)
      {
        const entry = this.perDutyConfig.find(item => item.date === date)
        if (!entry) return

        this.$set(entry, 'durationHours', durationHours)
      },

      removeDuty (date)
      {
        this.perDutyConfig = this.perDutyConfig.filter(entry => entry.date !== date)
        this.dutyDate = Array.isArray(this.dutyDate) ? this.dutyDate.filter(d => d !== date) : []
      },

      // Opções de duração (em horas) permitidas para um plantão que começa em "startHour" (limitado a
      // 23h e a no máximo 12h de duração)
      allowedDurationHoursFor (startHour)
      {
        const shiftHour = parseInt(startHour)
        if (isNaN(shiftHour)) return []

        let maxDuration = Math.max(0, 23 - shiftHour)
        maxDuration = maxDuration > 12 ? 12 : maxDuration

        return Array.from({ length: maxDuration }, (_, i) => {
          const duration = (i + 1).toString().padStart(2, '0')
          return { key: `dh_${duration}`, text: duration, value: duration }
        })
      },

      onSelectOwner (value)
      {
        this.slotOwner = value
      },

      onSelectSlotDuration (value)
      {
        this.slotDuration = value
      },

      // Ao selecionar o horário de início padrão, já aplica automaticamente a todos os plantões já
      // selecionados (sem precisar de um botão extra de confirmação)
      onSelectDefaultTime (time)
      {
        this.defaultStartTime = time

        const shiftHour = parseInt(time.hour)
        let maxDuration = Math.max(0, 23 - shiftHour)
        maxDuration = maxDuration > 12 ? 12 : maxDuration

        this.allowedDurationHours = Array.from({ length: maxDuration }, (_, i) => {
          const duration = (i + 1).toString().padStart(2, '0')
          return { key: `dh_${duration}`, text: duration, value: duration }
        })

        // Reseta a duração padrão para forçar uma nova seleção compatível com o novo horário
        this.defaultDurationHours = ''

        this.perDutyConfig = this.perDutyConfig.map(entry => ({
          ...entry,
          startHour: time.hour,
          startMinute: time.minute,
        }))
      },

      // Ao selecionar a duração padrão, já aplica automaticamente a todos os plantões já selecionados
      onSelectDefaultDuration (durationHour)
      {
        this.defaultDurationHours = durationHour

        this.perDutyConfig = this.perDutyConfig.map(entry => ({
          ...entry,
          durationHours: durationHour,
        }))
      },

      // Atualiza a quantidade TOTAL (entre todos os plantões selecionados) de vagas de um tipo clínico
      onSlotTypeCountInput (type, value)
      {
        this.$set(this.slotTypeCounts, type, Math.max(parseInt(value) || 0, 0))
      },

      //
      // Após os plantões serem criados, configura o TIPO e o OWNER de cada vaga (slot) individual
      // projetada, usando a distribuição já calculada em "distributedSlotsByDuty" — cada plantão/data
      // recebe apenas a sua própria lista de vagas (que pode variar em quantidade de um plantão para outro)
      //

      async persistSlotsConfiguration (dutyIDs)
      {
        if (!Array.isArray(dutyIDs) || dutyIDs.length === 0) return

        const { duties } = this.distributedSlotsByDuty
        if (!Array.isArray(duties) || duties.length === 0) return

        const { groupID = '', userID = '' } = this.$route.params
        const perDutyList = this.perDutyList

        const slots = []

        perDutyList.forEach((duty, dutyIndex) => {
          const dutyID = dutyIDs[dutyIndex]
          if (!dutyID) return

          const dutySlots = duties[dutyIndex] || []
          if (dutySlots.length === 0) return

          // Convenção do sistema (dutyStartDateTZ '+0000'): data_inicio (meia-noite UTC do dia) + hora_inicio (literal, sem deslocamento real de fuso)
          const dutyStartMoment = moment.utc(duty.date, 'DD/MM/YYYY').add(parseInt(duty.startTime.hour), 'hours').add(parseInt(duty.startTime.minute), 'minutes')

          dutySlots.forEach(slot => {
            const slotStartMoment = dutyStartMoment.clone().add(slot.offsetStartMinutes, 'minutes')
            const slotEndMoment = slotStartMoment.clone().add(slot.duration, 'minutes')

            slots.push({
              duty_id: dutyID,
              scale_id: this.scaleID,
              doctor_id: userID,
              slot_index: slot.slotIndex,
              slot_start: slotStartMoment.format('YYYY-MM-DD HH:mm:ss'),
              slot_end: slotEndMoment.format('YYYY-MM-DD HH:mm:ss'),
              slot_type: slot.slotType,
              owner_type: slot.ownerType,
            })
          })
        })

        if (slots.length === 0) return

        const response = await apiSetDutySlots({ groupID, slots })

        if (response.httpCode !== 200) {
          this.showMessage('Atenção!', 'Os plantões foram criados, mas não foi possível configurar o tipo e o dono das vagas individuais. Por favor, entre em contato com o suporte técnico.')
        }
      },

      cdAction (cdResponse)
      {
        if (cdResponse === false) return false

        const type = cdResponse.cdType

        if (type === 'addUser')
        {
          this.createDuty(false)
        }
      },

      //
      // CRIAR PLANTÃO DO USUÁRIO
      //

      async createDuty (validateConflicts = true)
      {
        if (this.loading) return false

        const { groupID = '', userID = '' } = this.$route.params
        const { scaleID = '' } = this

        const e = []

        if (scaleID.length === 0) e.push('Selecione uma escala!')
        if (this.slotOwner.length === 0) e.push('Selecione o destino dos slots (Município ou Reservado)!')
        if (!(parseInt(this.slotDuration) > 0)) e.push('Selecione o tempo de consulta!')

        const validDates = this.validDatesList

        if (validDates.length === 0) e.push('Selecione ao menos uma data!')
        if (validDates.length > 20) e.push('Selecione no máximo 20 dias!')

        this.perDutyList.forEach(duty => {
          if (duty.startTime.hour.length === 0) e.push(`Defina o horário de início do plantão de ${duty.date}!`)
          if (!(duty.durationHours > 0)) e.push(`Defina a duração do plantão de ${duty.date}!`)
        })

        const hasNegativeCounts = TYPE_ORDER.some(type => (parseInt(this.slotTypeCounts[type]) || 0) < 0)
        const distributedSlots = this.distributedSlotsCount

        if (hasNegativeCounts) e.push('As quantidades de vagas não podem ser negativas!')
        if (!(distributedSlots > 0)) e.push('Informe ao menos 1 vaga para distribuir ("1ª consulta", "Retorno" ou "Ambos")!')
        if (distributedSlots > this.totalAvailableSlots) e.push(`A quantidade de vagas configurada (${distributedSlots}) excede o total de slots disponíveis nos plantões selecionados (${this.totalAvailableSlots}).`)
        if (e.length === 0 && this.distributedSlotsByDuty.capacityError) e.push('Não foi possível distribuir todas as vagas configuradas entre os plantões selecionados. Revise a duração/quantidade dos plantões.')

        if (e.length > 0) return this.showMessage('Atenção!', e.join('<br>'))

        this.loading = true

        //
        // CONFLITOS
        //

        if (validateConflicts)
        {
          const selectedYear = Number(this.selectedYear)
          const selectedMonth = Number(this.selectedMonth) - 1

          const firstDate = moment.utc([selectedYear, selectedMonth, 1, 0, 0, 0, 0]).startOf('day')
          const lastDate = moment.utc([selectedYear, selectedMonth, 1, 0, 0, 0, 0]).endOf('month')

          // Cada plantão pode ter seu próprio horário de início, então agrupa as datas por horário
          // antes de checar conflitos (a função canAddUserShift verifica um único horário por chamada)
          const startTimeGroups = {}

          this.perDutyList.forEach(duty => {
            const key = duty.startLabel
            if (!startTimeGroups[key]) startTimeGroups[key] = []
            startTimeGroups[key].push(duty.date)
          })

          let combinedConflictedScales = []
          let combinedConflictsTableHtml = ''

          for (const [startTime, dates] of Object.entries(startTimeGroups)) {
            const { conflictedScales, conflictsTableHtml } = await canAddUserShift(startTime, dates, userID, firstDate, lastDate)

            if (conflictedScales.length > 0) {
              combinedConflictedScales = combinedConflictedScales.concat(conflictedScales)
              combinedConflictsTableHtml += conflictsTableHtml
            }
          }

          if (combinedConflictedScales.length > 0)
          {
            this.loading = false

            return this.showConfirmBox({
              title: 'Conflito!',
              text: `<div style="text-align: center">O usuário já tem algum plantão nas datas e horários que você selecionou.<br /><br />Veja os conflitos abaixo:<br /><br />${combinedConflictsTableHtml}<br /><b>Deseja adicionar o plantonista mesmo assim?</b></div>`,
              type: 'addUser',
              data: '',
              isResponse: false,
              buttonPosition: 'right',
              width: 330,
              closeText: 'Não',
              continueText: 'Sim',
            })
          }
        }

        //
        // Dados do plantão
        //

        const scale = this.groupScales.find(scaleItem => scaleItem.scaleID === scaleID)
        const dutyName = !!scale === true ? scale.scaleName : ''
        const dutyLocal = !!scale === true ? scale.scaleLocation.name : ''
        const scaleConsultationDuration = parseInt(this.slotDuration) || 0

        const DUTIES_OBJECT = this.perDutyList.map(duty => {
          const selectedDutyStartDate = moment.utc(duty.date, 'DD/MM/YYYY')
          const dataInicioFmt = selectedDutyStartDate.format('YYYY-M-D')
          const dutyStartDate = selectedDutyStartDate.unix() * 1000
          const dutyStartTime = `${duty.startTime.hour}:${duty.startTime.minute}`

          return {
            // Campo legado (plantoes/{dutyID}/slotType), mantido por compatibilidade com o fluxo antigo
            // de vagas em memória. Como o TIPO agora é definido por vaga (única, do owner selecionado),
            // usa-se "FREE" (Ambos/sem restrição) para não filtrar indevidamente nenhum consumidor
            // legado desse campo.
            slotType: 'FREE',
            scaleConsultationDuration,

            dutyGroupID: groupID,
            dutyScaleID: scaleID,
            dutyOwnerID: userID,

            dutyMessageDate: duty.date,
            dataInicioFmt,

            dutyStartDate,
            dutyStartTime,
            dutyDuration: duty.durationHours,

            dutyName,
            dutyLocal,

            dutyValue: duty.value,
          }
        })

        //
        // RUN DATABASE MASS INSERTION
        //

        apiCreateDuties(DUTIES_OBJECT, response => {
          this.loading = false

          if (response.code === 0) {
            this.showMessage('Erro', 'Desculpe, não foi possível criar o plantão. Por favor, entre em contato com o suporte técnico.')
          } else {
            this.isVisible = false
            this.showMessage('Sistema', 'Os plantões foram criados!')

            this.persistSlotsConfiguration(response.dutyIDs || [])
          }
        })
      },

      // Verifica se a data informada é final de semana ou dia de semana
      typeWeek (dateStr = '29/04/2025') {
        if (!this.dutyDate || this.dutyDate.length === 0) return false;

        const date = moment(dateStr, "DD/MM/YYYY");
        const dayOfWeek = date.day(); // 0 = Domingo, 6 = Sábado

        if (dayOfWeek === 0 || dayOfWeek === 6) {
          return 'weekend';
        }

        if (dayOfWeek >= 1 && dayOfWeek <= 5) { // Segunda (1) a Sexta (5)
          return 'weekdays';
        }
      },

      /**
       * Resolve a hierarquia de valores de acordo com o tipo de semana (final de semana ou dia de semana)
       * @param typeWeek = 'weekdays' ou 'weekend'
       * @param period = 'day', 'night' ou 'both'
       * @param findBy = 'none' ou 'key' - Se for 'key', retorna o objeto do valor hora da key informado
       */
      resolveHourlyRateHierarchy(typeWeek = '', period = '', findByKey = null) {
        // Hierarquia de valores horas restantes que não está vinculado ao usuário (sem prioridade)
        const noPriorityHourlyRates = {
          scaleValue: {
            key: 'scaleValue',
            value: this.scaleValue,
            formatted: this.scaleValueFormatted,
            period: 'both',
            ignoreWeek: true
          },
          userGroupHourlyRate: {
            key: 'userGroupHourlyRate',
            value: this.userGroupHourlyRate,
            formatted: this.userGroupHourlyRateFormatted,
            period: 'both',
            ignoreWeek: true
          },
        }

        // Hierarquia de valores horas restantes do usuário (sem prioridade)
        const userNoPriorityHourlyRates = {
          userSelectedScaleNightShiftHourlyRate: {
            key: 'userSelectedScaleNightShiftHourlyRate',
            value: this.userSelectedScaleNightShiftHourlyRate,
            formatted: this.userSelectedScaleNightShiftHourlyRateFormatted,
            period: 'night'
          },
          userSelectedScaleDayShiftHourlyRate: {
            key: 'userSelectedScaleDayShiftHourlyRate',
            value: this.userSelectedScaleDayShiftHourlyRate,
            formatted: this.userSelectedScaleDayShiftHourlyRateFormatted,
            period: 'day'
          },
          userSelectedScaleHourlyRate: {
            key: 'userSelectedScaleHourlyRate',
            value: this.userSelectedScaleHourlyRate,
            formatted: this.userSelectedScaleHourlyRateFormatted,
            period: 'both'
          },
        }

        // Hierarquia de valores horas para dia de semana
        const userWeekdaysHourlyRates = {
          userSelectedScaleWeekdaysNightShiftHourlyRate: {
            key: 'userSelectedScaleWeekdaysNightShiftHourlyRate',
            value: this.userSelectedScaleWeekdaysNightShiftHourlyRate,
            formatted: this.userSelectedScaleWeekdaysNightShiftHourlyRateFormatted,
            period: 'night'
          },
          userSelectedScaleWeekdaysDayShiftHourlyRate: {
            key: 'userSelectedScaleWeekdaysDayShiftHourlyRate',
            value: this.userSelectedScaleWeekdaysDayShiftHourlyRate,
            formatted: this.userSelectedScaleWeekdaysDayShiftHourlyRateFormatted,
            period: 'day'
          },
          userSelectedScaleWeekdaysHourlyRate: {
            key: 'userSelectedScaleWeekdaysHourlyRate',
            value: this.userSelectedScaleWeekdaysHourlyRate,
            formatted: this.userSelectedScaleWeekdaysHourlyRateFormatted,
            period: 'both'
          },
        }

        // Hierarquia de valores horas para final de semana
        const userWeekendHourlyRates = {
          userSelectedScaleWeekendNightShiftHourlyRate: {
            key: 'userSelectedScaleWeekendNightShiftHourlyRate',
            value: this.userSelectedScaleWeekendNightShiftHourlyRate,
            formatted: this.userSelectedScaleWeekendNightShiftHourlyRateFormatted,
            period: 'night'
          },
          userSelectedScaleWeekendDayShiftHourlyRate: {
            key: 'userSelectedScaleWeekendDayShiftHourlyRate',
            value: this.userSelectedScaleWeekendDayShiftHourlyRate,
            formatted: this.userSelectedScaleWeekendDayShiftHourlyRateFormatted,
            period: 'day'
          },
          userSelectedScaleWeekendHourlyRate: {
            key: 'userSelectedScaleWeekendHourlyRate',
            value: this.userSelectedScaleWeekendHourlyRate,
            formatted: this.userSelectedScaleWeekendHourlyRateFormatted,
            period: 'both'
          },
        }

        const allHourlyRates = {
          ...userWeekdaysHourlyRates,
          ...userWeekendHourlyRates,
          ...userNoPriorityHourlyRates,
          ...noPriorityHourlyRates
        }

        // Encontra o valor hora específico da key informada
        if (findByKey) return allHourlyRates[findByKey]

        // Percorre as hierarquias de valores de acordo com o tipo de semana (final de semana ou dia de semana)
        switch (typeWeek) {
          case 'weekdays': {
            return this.findRuleByPriorityHierarchy({
              period: period,
              hierarchyRules: userWeekdaysHourlyRates
            })
          }
          case 'weekend': {
            return this.findRuleByPriorityHierarchy({
              period: period,
              hierarchyRules: userWeekendHourlyRates
            })
          }
          default:
            return this.findRuleByPriorityHierarchy({
              period: period,
              hierarchyRules: userNoPriorityHourlyRates
            })
        }
      },

      /**
       * Encontra a regra de acordo com a prioridade (onde o primeiro valor do objeto é prioridade 1, o segundo valor é prioridade 2, etc)
       * @param props = {
       *  period: '', // 'day', 'night', 'both'
       *  hierarchyRules: []
       * }
       */
      findRuleByPriorityHierarchy(props = {
        period: '', // 'day', 'night', 'both'
        hierarchyRules: []
      }) {
        let result = null

        const found = Object.entries(props.hierarchyRules).find(([key, obj]) => {
          const isPeriodSelected = obj.value > 0 && obj.period === props.period
          const isBothPeriods = obj.value > 0 && obj.period === 'both';

          if (isPeriodSelected || isBothPeriods) {
            return obj
          }
        });

        if (found) result = found[1];

        // Se não encontrou, retorna um objeto zerado
        if (result === null) {
          result = {
            key: null,
            value: 0,
            formatted: 'R$ 0,00',
            period: null
          }
        }

        return result
      },

      //
      // Valor previsto de UM plantão específico, considerando sua própria data/duração/horário de
      // início — extraído da antiga calculate() (que assumia um único horário/duração global para
      // todos os plantões selecionados)
      //

      computeDutyValue (dateStr, durationMinutes, startHour)
      {
        if (!(durationMinutes > 0)) return 0

        const periodName = parseInt(startHour) >= 17 ? 'night' : 'day'
        const weekType = this.typeWeek(dateStr)

        if (this.selectedCalculationBase === 'user_scale')
        {
          if (weekType === 'weekdays') {
            const rate = this.resolveHourlyRateHierarchy('weekdays', periodName).value
            if (rate > 0) return (durationMinutes / 60) * rate
          }

          if (weekType === 'weekend') {
            const rate = this.resolveHourlyRateHierarchy('weekend', periodName).value
            if (rate > 0) return (durationMinutes / 60) * rate
          }

          const fallbackRate = this.resolveHourlyRateHierarchy('default', periodName).value
          return fallbackRate > 0 ? (durationMinutes / 60) * fallbackRate : 0
        }

        const findByKey = this.selectedCalculationBase === 'scale' ? 'scaleValue' : 'userGroupHourlyRate'
        const rate = this.resolveHourlyRateHierarchy('default', periodName, findByKey).value

        return rate > 0 ? (durationMinutes / 60) * rate : 0
      },

      //
      // EVENT HANDLING FOR EACH SELECT COMPONENT
      //

      onSelectScale (scaleID)
      {
        const scale = this.groupScales.length > 0 ? this.groupScales.find(scaleItem => scaleItem.scaleID === scaleID) : false

        if (!!scale === false) return false

        this.setScale(scale)
      },

      onSelectData (date)
      {
        this.syncPerDutyConfig()
      },

      onSelectBase (base)
      {
        this.selectedCalculationBase = base
      },

      //
      //
      //

      setScale (s) {
        this.scaleID = s.scaleID
        this.scaleValue = s.scaleValue
        this.scaleValueFormatted = s.scaleValueFormatted

        // Valor hora do plantonista dentro da escala selecionada
        const userID = this.$route.params.userID

        // Valor hora do usuário na escala
        const userSelectedScaleHasHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].hourlyrate === true
        const userSelectedScaleHourlyRate = userSelectedScaleHasHourlyRate ? s.scaleUsers[userID].hourlyrate : 0
        this.userSelectedScaleHourlyRate = userSelectedScaleHourlyRate
        this.userSelectedScaleHourlyRateFormatted = formatMoney(userSelectedScaleHourlyRate)

        // Valor hora do usuário de segunda a sexta
        const userSelectedScaleHasWeekdaysHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].weekdaysHourlyRate === true
        const userSelectedScaleWeekdaysHourlyRate = userSelectedScaleHasWeekdaysHourlyRate ? s.scaleUsers[userID].weekdaysHourlyRate : 0
        this.userSelectedScaleWeekdaysHourlyRate = userSelectedScaleWeekdaysHourlyRate
        this.userSelectedScaleWeekdaysHourlyRateFormatted = formatMoney(userSelectedScaleWeekdaysHourlyRate)

        // Valor hora do usuário de final de semana
        const userSelectedScaleHasWeekendHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].weekendHourlyRate === true
        const userSelectedScaleWeekendHourlyRate = userSelectedScaleHasWeekendHourlyRate ? s.scaleUsers[userID].weekendHourlyRate : 0
        this.userSelectedScaleWeekendHourlyRate = userSelectedScaleWeekendHourlyRate
        this.userSelectedScaleWeekendHourlyRateFormatted = formatMoney(userSelectedScaleWeekendHourlyRate)

        // Valor hora do usuário (diurno)
        const userSelectedScaleHasDayShiftHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].dayShiftHourlyRate === true
        const userSelectedScaleDayShiftHourlyRate = userSelectedScaleHasDayShiftHourlyRate ? s.scaleUsers[userID].dayShiftHourlyRate : 0
        this.userSelectedScaleDayShiftHourlyRate = userSelectedScaleDayShiftHourlyRate
        this.userSelectedScaleDayShiftHourlyRateFormatted = formatMoney(userSelectedScaleDayShiftHourlyRate)

        // Valor hora do usuário (noturno)
        const userSelectedScaleHasNightShiftHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].nightShiftHourlyRate === true
        const userSelectedScaleNightShiftHourlyRate = userSelectedScaleHasNightShiftHourlyRate ? s.scaleUsers[userID].nightShiftHourlyRate : 0
        this.userSelectedScaleNightShiftHourlyRate = userSelectedScaleNightShiftHourlyRate
        this.userSelectedScaleNightShiftHourlyRateFormatted = formatMoney(userSelectedScaleNightShiftHourlyRate)

        // Valor hora do usuário de segunda a sexta (diurno)
        const userSelectedScaleHasWeekdaysDayShiftHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].weekdaysDayShiftHourlyRate === true
        const userSelectedScaleWeekdaysDayShiftHourlyRate = userSelectedScaleHasWeekdaysDayShiftHourlyRate ? s.scaleUsers[userID].weekdaysDayShiftHourlyRate : 0
        this.userSelectedScaleWeekdaysDayShiftHourlyRate = userSelectedScaleWeekdaysDayShiftHourlyRate
        this.userSelectedScaleWeekdaysDayShiftHourlyRateFormatted = formatMoney(userSelectedScaleWeekdaysDayShiftHourlyRate)

        // Valor hora do usuário de segunda a sexta (noturno)
        const userSelectedScaleHasWeekdaysNightShiftHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].weekdaysNightShiftHourlyRate === true
        const userSelectedScaleWeekdaysNightShiftHourlyRate = userSelectedScaleHasWeekdaysNightShiftHourlyRate ? s.scaleUsers[userID].weekdaysNightShiftHourlyRate : 0
        this.userSelectedScaleWeekdaysNightShiftHourlyRate = userSelectedScaleWeekdaysNightShiftHourlyRate
        this.userSelectedScaleWeekdaysNightShiftHourlyRateFormatted = formatMoney(userSelectedScaleWeekdaysNightShiftHourlyRate)

        // Valor hora do usuário de final de semana (diurno)
        const userSelectedScaleHasWeekendDayShiftHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].weekendDayShiftHourlyRate === true
        const userSelectedScaleWeekendDayShiftHourlyRate = userSelectedScaleHasWeekendDayShiftHourlyRate ? s.scaleUsers[userID].weekendDayShiftHourlyRate : 0
        this.userSelectedScaleWeekendDayShiftHourlyRate = userSelectedScaleWeekendDayShiftHourlyRate
        this.userSelectedScaleWeekendDayShiftHourlyRateFormatted = formatMoney(userSelectedScaleWeekendDayShiftHourlyRate)

        // Valor hora do usuário de final de semana (noturno)
        const userSelectedScaleHasWeekendNightShiftHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].weekendNightShiftHourlyRate === true
        const userSelectedScaleWeekendNightShiftHourlyRate = userSelectedScaleHasWeekendNightShiftHourlyRate ? s.scaleUsers[userID].weekendNightShiftHourlyRate : 0
        this.userSelectedScaleWeekendNightShiftHourlyRate = userSelectedScaleWeekendNightShiftHourlyRate
        this.userSelectedScaleWeekendNightShiftHourlyRateFormatted = formatMoney(userSelectedScaleWeekendNightShiftHourlyRate)

        // Nota: o valor previsto de cada plantão agora é calculado individualmente (ver computeDutyValue),
        // acionado reativamente pelo computed perDutyList sempre que estes valores hora mudarem.
      },
    },
  }

</script>

<style lang="scss" scoped>

  .groupUserField--date {
    width: 100%;
  }

  //
  // --- Linha de campos lado a lado (layout largo)
  //

  .sosFieldsRow {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .sosFieldsRow__field {
    flex: 1 1 200px;
    min-width: 200px;
  }

  .sosFieldHint {
    margin-top: -6px;

    color: #6c757d;
    font-size: 11px;
  }

  .sosDefaultConfigBlock {
    margin-top: 8px;
    padding: 10px;
    border-radius: 7px;
    background-color: rgba(0, 0, 0, 0.03);
  }

  .sosSectionTitle {
    margin-top: 24px;
    margin-bottom: 10px;
    padding-bottom: 6px;
    border-bottom: 2px solid rgba(0, 0, 0, 0.15);

    color: #495057;
    font-size: 16px;
    font-weight: 700;
  }

  //
  // --- Tabelas (plantões / resultado / prévia / resumo)
  //

  .sosTableScroll {
    overflow-x: auto;
  }

  .sosDataTable {
    width: 100%;
    min-width: 560px;
    border-collapse: collapse;

    font-size: 13px;

    th,
    td {
      padding: 8px 10px;
      border: 1px solid rgba(0, 0, 0, 0.1);

      text-align: center;
      white-space: nowrap;
    }

    thead th {
      background-color: rgba(0, 0, 0, 0.04);

      color: #495057;
      font-weight: 600;
    }

    tfoot th,
    tfoot td {
      background-color: rgba(0, 0, 0, 0.04);

      font-weight: 700;
    }

    tbody tr:hover {
      background-color: rgba(0, 0, 0, 0.02);
    }
  }

  .sosDutiesTable__remove {
    .mdi {
      color: #c62828;
      font-size: 20px;
      cursor: pointer;

      &:hover {
        opacity: 0.7;
      }
    }
  }

  //
  // --- Dashboard (cards + barra de progresso + alertas)
  //

  .sosDashboard {
    margin-top: 16px;
    padding: 14px;
    border-radius: 7px;
    border: 2px solid rgba(0, 0, 0, 0.15);
  }

  .sosDashboard__grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 10px;
  }

  .sosDashboardCard {
    padding: 10px;
    border-radius: 6px;
    background-color: rgba(0, 0, 0, 0.04);

    text-align: center;
  }

  .sosDashboardCard__label {
    color: #6c757d;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
  }

  .sosDashboardCard__value {
    margin-top: 4px;

    color: #212529;
    font-size: 18px;
    font-weight: 700;
  }

  .sosDashboardCard--error {
    background-color: rgba(198, 40, 40, 0.1);

    .sosDashboardCard__value {
      color: #c62828;
    }
  }

  .sosProgressBar {
    margin-top: 14px;
  }

  .sosProgressBar__track {
    height: 10px;
    border-radius: 6px;
    background-color: rgba(0, 0, 0, 0.08);

    overflow: hidden;
  }

  .sosProgressBar__fill {
    height: 100%;
    background-color: cadetblue;
    transition: width 0.2s ease-in-out;
  }

  .sosProgressBar__fill--over {
    background-color: #c62828;
  }

  .sosProgressBar__label {
    margin-top: 4px;

    color: #495057;
    font-size: 11px;
    text-align: right;
  }

  .sosAlertBanner {
    margin-top: 10px;
    padding: 8px 12px;
    border-radius: 6px;
    background-color: rgba(0, 0, 0, 0.04);

    color: #495057;
    font-size: 12px;
  }

  .sosAlertBanner--error {
    background-color: rgba(198, 40, 40, 0.1);

    color: #c62828;
    font-weight: 600;
  }

</style>
